import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { LanguageSelectorComponent } from '../../shared/language-selector/language-selector.component';

@Component({
    selector: 'app-admin-login',
    imports: [CommonModule, ReactiveFormsModule, TranslateModule, LanguageSelectorComponent],
    templateUrl: './admin-login.component.html',
    styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent {
  loading = false;
  submitted = false;
  errorMessage = '';

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
    adminCode: ['', [Validators.required, Validators.pattern(/^\d{5}\D$/)]],
    rememberMe: [false]
  });

  constructor(private fb: FormBuilder, private auth: AuthService, private router: Router) {}

  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) return;
    const { email, password, adminCode } = this.form.value as any;
    this.loading = true;
    this.auth.loginAdmin(email, password, adminCode).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigate(['/admin']);
      },
      error: (err) => {
        this.loading = false;
        this.errorMessage = err?.error?.message || 'Login failed';
      }
    });
  }
}
